<app-shared-dialog [options]="{
  confirmText: 'common.confirm' | translate,
  confirmButtonStyle: 'primary-btn',
  cancelText: 'common.cancel' | translate,
  hideHeader: true
}" (confirm)="goBack()"
  (cancel)="cancel()">
  <div class="confirmation-dialog">
    <img src="assets/images/{{ data.catalogType === 'catalogs' ? 'shop' : 'briefcase-illustration' }}.svg" alt="" />
    <span class="title">
      {{ 'Catalogs.new_catalog.confirmation.subsidiary_change_title' | translate }}
    </span>
    <p class="sub">
      <ng-container *ngIf="data.catalogType === 'catalogs'">
        {{ 'Catalogs.new_catalog.confirmation.subsidiary_change_message_catalogs' | translate }}
      </ng-container>
      <ng-container *ngIf="data.catalogType === 'agents'">
        {{ 'Catalogs.new_catalog.confirmation.subsidiary_change_message_agents' | translate }}
      </ng-container>
    </p>
  </div>
</app-shared-dialog>
